import store from "@/core/services/store";
import router from "@/router"
import { CHECK_AUTH, LOGOUT } from "@/core/services/store/actions.type";

const setupRouter = () => {
  router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      store
        .dispatch(CHECK_AUTH)
        .then((data) => {
          if (store.getters.isAuthenticated) {
            const correctSlug = !data.u.is_admin ? data?.c?.slug : "admin";
            const routeSlug = to.params?.client_slug;
            if (routeSlug && correctSlug && routeSlug !== correctSlug) {
              return next({
                ...to,
                params: { ...to.params, client_slug: correctSlug },
                replace: true,
              });
            }        
            if ((to.name == "client.user" && data.u.roles == "staff") || (to.name == "client.service.create" && data.u.roles == "staff") || (to.name == "client.service.edit" && data.u.roles == "staff") || (to.name == "client.location.create" && data.u.roles == "staff") || (to.name == "client.location.edit" && data.u.roles == "staff")) {
              next({
                name: "client.dashboard", // back to safety route
                params: { client_slug: data.c.slug },
              });
            }
            if (to.meta.is_admin == data.u.is_admin) {
              next();
            }
            if (to.meta.is_client == data.u.is_client && data.u.is_admin == 0) {
              next();
            } else {
              if (to.meta.is_service_provider == data.u.is_service_provider) {
                next();
              } else {
                if (store.getters.currentUser.u.is_admin == 1) {
                  next();
                } else {
                  next({
                    name: "client.dashboard", // back to safety route //
                  });
                }
              }
            }
          } else {
            // store.commit(PURGE_AUTH);
            store.dispatch(LOGOUT).then(() => {
              next({
                name: "client.login",
              });
            });
          }
        })
        .catch((response) => {
          // Only force a logout on a genuine 401 (invalid/expired token).
          // Any other failure (network error, server restarting, etc.) has
          // no response at all -- don't destroy a still-valid session over it.
          if (response && response.status === 401) {
            store.dispatch(LOGOUT).then(() => {
              next({
                name: "client.login",
              });
            });
          } else {
            next(false);
          }
        });
    } else {
      if (to.name == "client.login") {
        if (store.getters.isAuthenticated) {
          store
            .dispatch(CHECK_AUTH)
            .then((data) => {
              next({
                name: "client.dashboard", // back to safety route
                params: { client_slug: data.c.slug },
              });
            })
            .catch((response) => {
              if (response && response.status === 401) {
                store.dispatch(LOGOUT);
              }
            });
        }
      }
      next();
    }
  });

  return router;
};

export default setupRouter;
